import React from 'react'
import DefaultLayout from '../DefaultLayout'

const PerformanceWrapper = () => {
    return (
        <div className='py-20'>
            <DefaultLayout className='px-6'>
                <>

                    <div className='text-main-800 mb-8'>
                        <h2 className='text-2xl font-semibold mb-8 text-center'>
                            性能について
                        </h2>
                    </div>

                    <div className='flex flex-col sm:flex-row gap-x-6 mb-10'>
                        <table className="table-auto w-full text-sm text-left text-gray-500 mb-10">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                <tr className='bg-main-600 text-white text-xl'>
                                    <th colSpan={10} className="w-full py-3 px-6 text-center">性能</th>
                                </tr>
                            </thead>
                            <tbody className='text-base sm:text-lg border border-white'>
                                <tr className='bg-main-200 border border-white'>
                                    <td colSpan={2} rowSpan={2} className="py-2 px-4 border-r border-white">Sp02</td>
                                    <td colSpan={4} className="py-2 px-4 border-r border-white">測定範囲</td>
                                    <td colSpan={4} className="py-2 px-4">70% - 100%</td>
                                </tr>
                                <tr className='bg-main-200'>
                                    <td colSpan={4} className="py-2 px-4 border-r border-white">測定制度</td>
                                    <td colSpan={4} className="py-2 px-4">± 3%</td>
                                </tr>
                                <tr className='bg-main-100 border border-white'>
                                    <td colSpan={2} rowSpan={2} className="py-2 px-4 border-r border-white">脈拍数</td>
                                    <td colSpan={4} className="py-2 px-4 border-r border-white">測定範囲</td>
                                    <td colSpan={4} className="py-2 px-4">30 - 240bpm</td>
                                </tr>
                                <tr className='bg-main-100 border border-white'>
                                    <td colSpan={4} className="py-2 px-4 border-r border-white">測定制度</td>
                                    <td colSpan={4} className="py-2 px-4">± 2%</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="table-auto w-full text-sm text-left text-gray-500">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                <tr className='bg-main-600 text-white text-xl'>
                                    <th colSpan={10} className="w-full py-3 px-6 text-center">デバイス仕様</th>
                                </tr>
                            </thead>
                            <tbody className='text-base sm:text-lg'>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>材質</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>316Lステンレス鋼、PC</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>表面処理</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>PVD</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>防水防塵</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>IP65</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>センサー</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>6軸加速度センサー、３波長LED</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>ブルートゥース通信距離</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>＜3メートル</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>ブルートゥース通信規格</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>BLE4.2</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>バッテリー持続時間</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>12時間（1秒毎記録＆連続測定）</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>重さ</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>10g(S)/10.2g(L)</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>充電</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>5V、＜80mA</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>充電時間</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>＜2時間</td>
                                </tr>
                                <tr className='border border-white'>
                                    <td colSpan={3} className='bg-main-200 py-2 px-4 border-r border-white'>動作環境温度</td>
                                    <td className='bg-main-100 py-2 px-4' colSpan={7}>-10℃～45℃</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>


                    <div className='text-main-800'>
                        <h3 className='font-semibold mb-2'>注意事項</h3>
                        <ul className='list-disc text-sm tracking-wide'>
                            <li className='ml-4 mb-1'>本デバイスから出力する情報を、臨床診断や治療の唯一の根拠として依拠しないようお願いします。</li>
                            <li className='ml-4 mb-1'>血圧は開発途中の機能で、医療機器認証項目ではありません。</li>
                            <li className='ml-4 mb-1'>麻酔薬などの可燃性物質がある環境では使用しないでください。</li>
                            <li className='ml-4 mb-1'>MRI、CT検査と併用しないでください。</li>
                            <li className='ml-4 mb-1'>高温や高圧での滅菌をしないでください。</li>
                            <li className='ml-4 mb-1'>使用時は強い電界や磁界を発生する機器に近づけないでください。</li>
                            <li className='ml-4 mb-1'>バッテリー寿命を維持するため、月に2回以上リングを充電することをお勧めします。</li>
                            <li className='ml-4 mb-1'>誤飲の危険性があるため、5歳未満のお子様の手の届かないところにリングを保管してください。</li>
                            <li className='ml-4 mb-1'>リングのお手入れは、柔らかい布または綿棒とアルコールだけで行ってください。</li>
                        </ul>
                    </div>

                </>
            </DefaultLayout>
        </div >
    )
}

export default PerformanceWrapper